import type { FacetValue } from "../facet-value";
import type { TrackingLabels } from "./TrackingLabels";

export type FeatureTracking = {
  labels: object;
  id: string;
  name: string;
  parentId?: string;
  position?: string;
  status?: string;
  method?: string;
};

export function removeStatusIf<T extends FeatureTracking | undefined>(condition: boolean, featureTracking: T): T {
  return condition && featureTracking ? { ...featureTracking, status: undefined } : featureTracking;
}

export function removeStatus(facetValue: FacetValue): FacetValue {
  return updateFeatureTrackingAttribute(facetValue, "status", undefined);
}

export function updateFeatureTrackingAttribute(
  facetValue: FacetValue,
  attribute: "position" | "status" | "method",
  value: string | undefined,
): FacetValue {
  if (facetValue.featureTracking) {
    facetValue.featureTracking[attribute] = value;
  }
  return facetValue;
}

export function updateFeatureTrackingLabel<T extends keyof TrackingLabels>(
  featureTracking: FeatureTracking,
  label: T,
  value: TrackingLabels[T],
): FeatureTracking {
  return {
    ...featureTracking,
    labels: {
      ...featureTracking?.labels,
      [label]: [value],
    },
  };
}

export function updateMethod(
  featureTracking: FeatureTracking | undefined,
  method: TrackingLabels["san_FilterMethod"],
): FeatureTracking | undefined {
  if (!featureTracking) {
    return undefined;
  }
  return {
    ...featureTracking,
    method: method,
  };
}
